import { render, staticRenderFns } from "./BorrowableAssetDetail.vue?vue&type=template&id=3a6ca183&scoped=true&"
import script from "./BorrowableAssetDetail.vue?vue&type=script&lang=js&"
export * from "./BorrowableAssetDetail.vue?vue&type=script&lang=js&"
import style0 from "./BorrowableAssetDetail.vue?vue&type=style&index=0&id=3a6ca183&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ca183",
  null
  
)

export default component.exports